import styled from '@emotion/styled/macro';

export const TablesWrapper = styled.div`
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  min-height: 30rem;
`;
